import { IUser } from 'common/interfaces/user';
import { ITimeValue } from 'components/calendar';
import * as moment from 'moment';

export interface IActivitiesInfo {
    total: number;
    limit: number;
    skip: number;
    data: IActivity[];
}

export interface IActivities {
    id: number;
    activities: IActivity[];
}

export interface IReminder {
    activity: IActivity;
    remindAt: string;
}

export interface IActivity {
    activityType: {
        name: string;
    };
    activityTypeId: number;
    assignedToUserId: number;
    assignedToUser: IActivityUser;
    createdByUser: IActivityUser;
    createdAt: string;
    createdByUserId: number;
    finished: boolean;
    id: number;
    note?: string;
    provider: {
        databaseId: number;
        providerId: string;
        dba: string;
        legalBusName: string;
    };
    activityTime: string;
    providerId: number;
    remind: boolean;
    remindAt: string;
    showReminder: boolean;
    status: string;
    updatedAt: string;
    viewed: boolean;
    savingComplete: boolean;
}

export interface IActivityUser {
    name: string;
    username: string;
    id: number;
    email: string;
}

export interface IActivityType {
    id: number;
    name: string;
}

export interface IActivitiesGroup {
    key: string;
    title: string;
    allFinished: boolean;
    activities: IActivityShort[];
}

export interface IActivityShort {
    id: number;
    time: moment.Moment | null;
    title: string;
    note: string;
    author: IActivityUser;
    assignedToUser: IActivityUser;
    finished: boolean;
    provider: IActivityProvider;
    savingComplete: boolean;
}

export interface IActivityProvider {
    databaseId: number;
    dba: string;
    legalBusName: string;
    providerId: string;
}

export interface IActivityTypeApi {
    total: number;
    limit: number;
    skip: number;
    data: Array<{ id: number; name: string }>;
}

export enum NewActivityStatus {
    None,
    Saving,
    Error,
    Success,
}

export interface ICreateActivity {
    providerId: number | null;
    typeId: number | null;
    typeName: string | null;
    date: moment.Moment | null;
    remindAt: {
        value: number | null;
        label: string | null;
    };
    time: {
        value: ITimeValue | null;
        label: string | null;
    };
    createdByUserId: number | null;
    assignedToUserId: number | null;
    assignedToUserName: string | null;
    descriptionHtml: string;
    descriptionText: string;
    descriptionTooLong: boolean;
    status: NewActivityStatus;
}

export interface IEditActivity extends ICreateActivity {
    activityId: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/activity.ts